import { render } from "./MonthlyExpenseManager.vue?vue&type=template&id=96083448&scoped=true"
import script from "./MonthlyExpenseManager.vue?vue&type=script&lang=js"
export * from "./MonthlyExpenseManager.vue?vue&type=script&lang=js"

import "./MonthlyExpenseManager.vue?vue&type=style&index=0&id=96083448&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96083448"]])

export default __exports__